<div class="row m-0">
  <span
    ><button class="btn back_btn" [routerLink]="['/main/home']">
      Back
    </button></span
  >
</div>
<div
  class="container"
  style="padding: 50px; width: 800px; border: solid 1px grey"
>
  <div class="row col-md-12">
    <div class="col-md-6">
      <h3 style="margin-top: 35px; margin-left: 25px">
        {{ scholarshipsList.title }}
      </h3>
    </div>
    <div class="col-md-6">
      <img
        [src]="
          scholarshipsList.image
            ? scholarshipsList.image
            : '../../../assets/images/dummy_img.svg'
        "
        class="card-img-top cover_"
        alt="..."
      />
    </div>
  </div>
  <div class="row" style="margin-top: 25px">
    <div *ngFor="let item of questList; let i = index">
      <div class="col-md-12">{{ i + 1 }}. {{ item.title }}</div>
      <div class="col-md-12" *ngIf="item.type == 'text'">
        <textarea
          name=""
          id=""
          cols="4"
          rows="2"
          class="form-control w-100"
          style="margin-bottom: 15px"
          [(ngModel)]="item.valuesText"
        ></textarea>
      </div>
      <div
        *ngIf="item.valuesText == '' && item.isRequired == true && isSubmit"
        style="color: red"
      >
        *Required
      </div>
      <!-- <div class="col-md-12" *ngIf="item.type !== 'text'">
         <input type="file">
        </div> -->
      <div class="input-group">
        <div class="custom-file" *ngIf="item.type !== 'text'">
          <input
            type="file"
            accept="video/mp4,video/mkv, video/x-m4v,video/*"
            class="custom-file-input"
            id="inputGroupFile01"
            aria-describedby="inputGroupFileAddon01"
            (change)="onPicsfileChanged($event, i)"
            style="margin-bottom: 15px"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 text-center">
      <button
        class="btn apply_ ms-3"
        (click)="SubmitData()"
        style="background: #4b3e90"
      >
        Submit
      </button>
    </div>
  </div>
</div>
